import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterGbuModel } from 'src/app/models/interfaces/gbus/IFilterGbuModel';
import { IGbuModel } from 'src/app/models/interfaces/gbus/IGbuModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GbuService {

  private configUrl = [environment.apiGatewayUrl, 'gbu'].join('/');
  constructor(private http: HttpClient) { }

  getListFiltered(
    model: IFilterGbuModel
    ) : Observable<SearchResultModel<IGbuModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if (model.nombre !== '') {
      queryParams.push(`nombre=${model.nombre}`);
    }

    return this.http.get<SearchResultModel<IGbuModel[]>>(
      `${this.configUrl}/filtrar?${queryParams.join('&')}`
    );
  }

  getAllList(
    model: IFilterGbuModel
    ) : Observable<IGbuModel[]> {
    let queryParams: string[] = new Array<string>();

    // queryParams.push(`page=${model.page}`);
    // queryParams.push(`take=${model.pageSize}`);

    return this.http.get<IGbuModel[]>(
      `${this.configUrl}/all?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<IGbuModel> {
    return this.http.get<IGbuModel>(`${this.configUrl}/${id}`);
  }

  submit(model: IGbuModel) {
    return this.http.post<IGbuModel>(`${this.configUrl}`, model);
  }

  update(model: IGbuModel) {
    return this.http.put<IGbuModel>(
      `${this.configUrl}/${model.idGbu}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<IGbuModel>(`${this.configUrl}/${id}`);
  }
}
